import { createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {};

export const getProfileData = createAsyncThunk(
  'user/getProfileData',
  async (userId, thunkAPI) => {
    // minimal placeholder: return empty profile
    return {};
  }
);

export default function userSlice(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
